import { apiSlice } from "./apiSlice";

export const previousReleaseApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getPreviousReleases: builder.query({
            query: () => `file_download/previous_releases/summary`,
            providesTags: (result, error, { database }) => {
                return [{ type: "PreviousRelease" }, { type: 'Database', id: database }];
            },
        }),
        previousReleaseTransfer: builder.mutation({
            query: ({ version, dataset, pipeline, source, page, limit }) => {
                return {
                    url: 'file_download/previous_releases/transfer',
                    method: 'POST',
                    body: {
                        "version"  : version,
                        "dataset"  : dataset,
                        "pipeline" : pipeline,
                        "source"   : source,
                        "page"     : page,
                        "limit"    : limit,
                    }
                }
            }
        })
    })
})

export const {
    useGetPreviousReleasesQuery
} = previousReleaseApiSlice;